import { inject } from '@angular/core';
import { Routes } from '@angular/router';
import { PageLayout } from './page-layout/page-layout';
import { UserService } from './user.service';

/** Client-side convenience only; the server enforces admin access on every /api/admin call. */
const adminOnly = async () => {
  const users = inject(UserService);
  if (!users.isBrowser) return true;
  if (!users.me()) await users.refreshMe();
  return users.isAdmin();
};

export const routes: Routes = [
  { path: '', pathMatch: 'full', loadComponent: () => import('./chat/chat').then((m) => m.Chat) },
  {
    path: 'c/:id',
    loadComponent: () => import('./chat/chat').then((m) => m.Chat),
    data: { title: 'Chat' },
  },
  // Advanced mode used to live here; it's a toggle in every chat now.
  { path: 'advanced', pathMatch: 'full', redirectTo: '' },
  { path: 'advanced/:id', redirectTo: 'c/:id' },
  {
    path: '',
    component: PageLayout,
    children: [
      {
        path: 'r/:id',
        loadComponent: () => import('./results/results').then((m) => m.Results),
        data: { noindex: true },
      },
      {
        path: 'm/:id',
        loadComponent: () => import('./multi-results/multi-results').then((m) => m.MultiResults),
        data: { noindex: true },
      },
      {
        path: 'multi',
        loadComponent: () => import('./multi/multi').then((m) => m.Multi),
        data: { title: 'Compare models' },
      },
      {
        path: 'status',
        loadComponent: () => import('./status/status').then((m) => m.StatusPage),
        data: { title: 'Network status' },
      },
      {
        path: 'account',
        loadComponent: () => import('./account/account').then((m) => m.Account),
        data: { title: 'Account' },
      },
      {
        path: 'nodes/:id',
        loadComponent: () => import('./node-dashboard/node-dashboard').then((m) => m.NodeDashboard),
        data: { title: 'Node', noindex: true },
      },
      {
        path: 'api-keys',
        loadComponent: () => import('./api-keys/api-keys').then((m) => m.ApiKeys),
        data: { title: 'API keys' },
      },
      {
        path: 'admin',
        canActivate: [adminOnly],
        loadChildren: () => import('./admin/admin.routes').then((m) => m.adminRoutes),
        data: { noindex: true },
      },
      // The API docs moved into the documentation section.
      { path: 'developers', redirectTo: 'documentation/api' },
      {
        path: 'privacy',
        loadComponent: () => import('./privacy-policy/privacy-policy').then((m) => m.PrivacyPolicy),
        data: { title: 'Privacy' },
      },
      {
        path: 'terms',
        loadComponent: () => import('./terms/terms').then((m) => m.Terms),
        data: { title: 'Terms of Service' },
      },
      {
        path: 'about',
        loadComponent: () => import('./about/about').then((m) => m.About),
        data: { title: 'About' },
      },
      {
        path: 'credits',
        loadComponent: () => import('./credits/credits').then((m) => m.Credits),
        data: { title: 'How credits work' },
      },
      {
        path: 'become-a-provider',
        loadComponent: () =>
          import('./become-a-provider/become-a-provider').then((m) => m.BecomeAProvider),
        data: { title: 'Run a node' },
      },
      {
        path: 'documentation',
        loadChildren: () =>
          import('./documentation/documentation.routes').then((m) => m.documentationRoutes),
      },
    ],
  },
  { path: '**', redirectTo: '' },
];
